import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminToken } from '../../services/adminApi';

/**
 * Guards super-admin routes. Redirects to /admin/login when no token is present.
 * The actual server-side validity of the token is enforced by the API; if it
 * has expired or been revoked, the protected page will receive a 401 and
 * clear the token itself.
 */
export const AdminProtectedRoute = ({ children }) => {
  if (!getAdminToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default AdminProtectedRoute;
